<script lang="ts">
  import type { Snippet } from "svelte";
  import type { ClassValue } from "svelte/elements";

  interface Props {
    children?: Snippet;
    class?: ClassValue;
    onclick?: (event: MouseEvent) => void;
    onkeydown?: (event: KeyboardEvent) => void;
    role?: string;
    tabindex?: number;
  }

  let { children, class: className, onclick, onkeydown, role, tabindex, ...rest }: Props = $props();
</script>

<tr
  {...rest}
  class={["align-middle", className]}
  style="height: 40px;"
  {onclick}
  {onkeydown}
  {role}
  {tabindex}
>
  {@render children?.()}
</tr>
